import { AcLockObject } from '@utils/ac-lock-object';

export const TITLES = AcLockObject({
  ABOUT: 'Over Open Tilburg',
  ACCESSIBILITY: 'Toegankelijkheid',
  BASE: 'Open Tilburg',
  CONTACT: 'Contact',
  COOKIES: 'Cookies',
  FAQ: 'Veelgestelde vragen',
  HOME: 'Overzicht',
  ORGANIZATION: 'Organisatie en werkwijze',
  PRIVACY: 'Privacy',
  PROCLAIMER: 'Proclaimer',
  PUBLICATION: 'Publicatie',
  REACH_OUT: 'Bereikbaarheidsgegevens',
  SEARCH: 'Zoeken',
  SITEMAP: 'Sitemap',
  THEMES: 'Onderwerpen',
  WEBSITE: 'www.tilburg.nl',
  WOO: 'WOO verzoek indienen',
});
